<template>
    <div class="access-layout">
        <div class="form-container">
            <div class="form-content">
                <img
                    src="img/logo/ppd_analytics.svg"
                    class="form-content__logo"
                    alt="PPD Digital Analytics"
                />

                <h2>
                    {{ formTitle }}
                </h2>

                <main>
                    <slot name="form" />
                </main>

                <FooterComponent class="mt-8" />
            </div>
        </div>

        <!-- RESERVE FOR INFOGRAPHIC SECTION -->
        <div class="form-info sm:px-6 lg:px-20 xl:px-24">
            <div>
                <h1>The next-generation brand marketing tool</h1>
                <p>
                    Know your brands' digital healthcare activities. Get
                    exclusive access to aggregated and up-to-date reports based
                    on doctors' prescriptions.
                </p>
                <img src="img/aesthetics/login.svg" alt="login" />
            </div>
        </div>
    </div>
</template>

<script>
import { FooterComponent } from "@CommonComponents";

export default {
    name: "AccessLayoutComponent",
    components: {
        FooterComponent,
    },
    props: {
        formTitle: { type: String, default: "Create an account" },
    },
    setup() {},
};
</script>

<style lang="scss">
.access-layout {
    @apply relative bg-white flex min-h-screen;
    .form-container {
        @apply flex-1 flex flex-col justify-center py-12 px-4 bg-gray-50;
        .form-content {
            @apply mx-auto w-full max-w-sm;
            &__logo {
                @apply w-auto mx-auto mb-6;
                height: 58px;
            }
            h2 {
                @apply text-3xl leading-9 font-semibold text-gray-900 text-center mb-8;
            }
        }
    }
    .form-info {
        @apply flex-1 bg-green-50 hidden;
        & > div {
            max-width: 448px;
            min-width: 300px;
        }
        h1 {
            @apply text-3xl leading-9 font-semibold mb-3;
        }
        p {
            @apply text-lg leading-6 font-normal mb-3;
        }
        img {
            @apply mx-auto;
        }
    }
}
@screen sm {
    .access-layout {
        .form-container {
            @apply px-6;
        }
    }
}
@screen lg {
    .access-layout {
        .form-container {
            @apply px-20;
            .form-content {
                width: 448px !important;
                @apply max-w-md flex-none;
            }
        }
        .form-info {
            @apply flex items-center justify-center;
        }
    }
}
@screen xl {
    .access-layout {
        .form-container {
            @apply px-24;
        }
    }
}
</style>